import { find } from 'lodash';

export const BELLS_PER_DOLLAR = 10;

export const priceToBells = (priceInDollars) =>
    Math.ceil(priceInDollars * BELLS_PER_DOLLAR);

export const bellsToPrice = (bells) => Math.ceil(bells / BELLS_PER_DOLLAR);

export const getAddOnBellsCost = (addOn, priceGroup) => {
    if (!addOn) return 0;
    const bellsCosts =
        addOn.addOnInformation?.addOnBellsCosts || addOn.addOnBellsCosts || [];
    const match = find(bellsCosts, { pricingGroupId: priceGroup });
    return (
        match?.bellsCost ??
        addOn.baseBellsCost ??
        priceToBells(addOn.addOnInformation?.price ?? addOn.price ?? 0)
    );
};

export const getConfiguredAddOnBellsCost = (addOn, priceGroup) => {
    if (!addOn) return null;
    const bellsCosts =
        addOn.addOnInformation?.addOnBellsCosts || addOn.addOnBellsCosts || [];
    const match = find(bellsCosts, { pricingGroupId: priceGroup });
    const value = match?.bellsCost ?? addOn.baseBellsCost ?? null;
    if (value === null || value === undefined) return null;
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return null;
    return numeric;
};

export const canPayAddOnWithBells = (addOn, priceGroup) =>
    getConfiguredAddOnBellsCost(addOn, priceGroup) !== null;

export const computeBellsFromCart = (items) => {
    const bellsItems = (items || []).flatMap((item) =>
        (item.addOns || [])
            .filter((addon) => addon.useBells)
            .map((addon) => ({
                title: addon.title,
                bellsCost: addon.bellsCost ?? priceToBells(addon.price)
            }))
    );
    const totalBellsUsed = bellsItems.reduce((sum, i) => sum + i.bellsCost, 0);
    return { bellsItems, totalBellsUsed };
};

export const sumAddOnPricesExcludingBells = (addOns) => {
    return (addOns || [])
        .filter((addon) => !addon.useBells)
        .reduce((sum, addon) => sum + addon.price, 0);
};
